module.exports = __webpack_public_path__ + "img/logo.05365bac.png";